unit Essentials.Shared;

interface

Uses
  System.SysUtils,
{$IFDEF PAS2JS}
  Generics.Collections,
{$ELSE}
  System.Generics.Collections,
{$ENDIF}
  {$IFNDEF PAS2JS}
  Aurelius.Mapping.Attributes
  {$ENDIF}
  {$IFDEF PAS2JS}
  JS,
  Weblib.JSON
  {$ENDIF};

{$SCOPEDENUMS ON}

Type
{$IFNDEF PAS2JS}
  [Enumeration(TEnumMappingType.emString, 'Text,Number,Integer,Date')]
{$ENDIF}
  TsxeValueType = (Text, Number, Integer, Date);

TdtoLookupDef = class
  EntityClassName: string;
  LookupFields: TList<String>;
  constructor Create;
  {$IFDEF PAS2JS}
  constructor CreateFromJSON(const Value: JSValue);
  {$ENDIF}
  destructor Destroy; override;
end;




implementation

{$SCOPEDENUMS OFF}

{$IFDEF PAS2JS}
uses SMX.XDataSvc.Utils;
{$ENDIF}

{ TdtoLookupDef }

constructor TdtoLookupDef.Create;
begin
  LookupFields := TList<string>.Create;
end;
{$IFDEF PAS2JS}
constructor TdtoLookupDef.CreateFromJSON(const Value: JSValue);
var
  LArray: TJSArray;
  lObject: TJSObject;
  I: Integer;
  S: String;
begin
  Create;
  lObject := JS.ToObject(Value);

  S := String(lObject['EntityClassName']);
  self.EntityClassName := S;
  LArray := JS.ToArray(lObject['LookupFields']);
  for I := 0 to LArray.Length - 1 do
  begin
     S := JS.toString(LArray[I]);
     LookupFields.Add(S);
  end;
end;
{$ENDIF}

destructor TdtoLookupDef.Destroy;
begin
  LookupFields.Free;
  inherited;
end;



end.
